import { Box } from "@mui/material";
import axios from "axios";
import { apiUrl } from "features/configure";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import useWindowWidth from "hooks/useWindowWidth";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useOutletContext } from "react-router";

export default function useGetTrainingData() {
  const { formatMessage } = useIntl();
  const [entityName] = useOutletContext();
  const [page, setPage] = useState(1);
  const [dataCounts, setDataCounts] = useState(1);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({});
  const [canUpdateResponse, setCanUpdateResponse] = useState(false);
  const [search, setSearch] = useState("");
  const windowWidth = useWindowWidth();
  const tableCellWidth = parseInt(windowWidth - 900) / 3;
  const [isLoading, setIsLoading] = useState(true);
  const headCells = [
    {
      show: true,
      disabledSort: true,
      id: "input",
      label: "Input",
      title: formatMessage({ id: "trainingArea.column.input" }),
      width: tableCellWidth,
    },
    {
      show: true,
      disabledSort: true,
      id: "response",
      label: "AI-Generated Response",
      title: formatMessage({ id: "trainingArea.column.aiResponse" }),
      width: tableCellWidth,
    },
    {
      show: true,
      disabledSort: true,
      id: "improvedResponse",
      label: "Improved Response",
      title: formatMessage({ id: "trainingArea.column.improvedResponse" }),
      width: tableCellWidth,
    },
  ];

  const dispatchSnackbar = useDispatchSnackbar();

  async function handleRefine() {
    try {
      setIsLoading(true);
      const res = await axios.post(
        `${apiUrl}/api/trainingArea/${entityName}/refine`
      );
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setIsLoading(false);
    }
  }
  const {
    feedbackType = null,
    feedbackFrom = null,
    improvedResponse = null,
  } = filter;

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await axios(
        `${apiUrl}/api/trainingArea/${entityName}/messages`,
        {
          params: {
            page,
            feedbackType,
            feedbackFrom,
            improvedResponse,
            search,
          },
        }
      );
      setData(res.data.messages);
      setCanUpdateResponse(res.data.hasUntrainedFeedback);
      setDataCounts(res.headers["x-total-count"]);
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setIsLoading(false);
    }
  };

  async function handleRefine() {
    try {
      const res = await axios.post(
        `${apiUrl}/api/trainingArea/${entityName}/refine`
      );
      setCanUpdateResponse(false);
    } catch (err) {
      dispatchSnackbar({ err });
    }
  }

  return {
    headCells,
    data,
    fetchData,
    handleRefine,
    isLoading,
    dataCounts,
    page,
    setPage,
    filter,
    setFilter,
    canUpdateResponse,
    handleRefine,
    setCanUpdateResponse,
    search,
    setSearch,
  };
}
